'use strict';

var WishketSymbolText = require('./Icons/WishketSymbolText.js');
var WishketSymbol = require('./Icons/WishketSymbol.js');
var WishketText = require('./Icons/WishketText.js');
var YozmITSymbolText = require('./Icons/YozmITSymbolText.js');
var YozmITSymbol = require('./Icons/YozmITSymbol.js');
var YozmITText = require('./Icons/YozmITText.js');
var JobsSymbol = require('./Icons/JobsSymbol.js');

const LogoMap = new Map([
    [
        'wishket_symbol',
        WishketSymbol
    ],
    [
        'wishket_symbol_text',
        WishketSymbolText
    ],
    [
        'wishket_text',
        WishketText
    ],
    [
        'yozmIT_symbol',
        YozmITSymbol
    ],
    [
        'yozmIT_symbol_text',
        YozmITSymbolText
    ],
    [
        'yozmIT_text',
        YozmITText
    ],
    [
        'jobs_symbol',
        JobsSymbol
    ]
]);

exports.LogoMap = LogoMap;
